import React, { useEffect, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getItemListSize, getProjectApi, getProjectCategory, putProjectViewCount } from "../api";
import config from "../config";
import PlaceCard from "./PlaceCard";
import UserCard from "./UserCard";
import UserCardWrapper from "./UserCardWrapper";

const HomeSection = () => {
    const [data1, setData1] = useState([]);
    const [project, setProject] = useState({});
    const [categoryList, setCategoryList] = useState([]);

    const getAPI = async()=>{


	const res =  getProjectCategory();			
	const res1 =  getProjectApi(config.project.id);		
	const res3 =  getItemListSize(6);


	Promise.all([res,res1,res3]).then((sonuclar)=>{
		////console.log("sonuclar ",sonuclar);
		setCategoryList(sonuclar[0].data);
        setData1(sonuclar[2].data);
        setProject(sonuclar[1].data);
        

	})

    putProjectViewCount({})

    }
    useEffect(() => {
      getAPI(); 
    }, [])
    

    return (
        <div className="home-sections">
            <Container>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="title">ANSİKLOPEDİDE YENİ</h2>
                    <Link className="seeAll" to="/maddeler">Tümü</Link>
                </div>
                <UserCardWrapper>
                    <Row>
                        {data1.map((item, i) => (
                              <Col key={i} xs={6}>
                                <UserCard info={item} />
                              </Col>
                            ))}
                    </Row>
                </UserCardWrapper>
                         
                <div className="d-md-flex justify-content-center mt-4">
                    <h2 className="title _secondary">KATEGORİLER</h2>
                </div>
                <UserCardWrapper>
                    <Row className="d-sm-flex">
                        {categoryList.map((category, i) => (
                            //   <Col key={i} md={i < 2 ? 6 : 4}>
                                                              <Col key={i} md={4} sm={6} xs={6}>

                                <PlaceCard info={{...category,image: require(`../assets/category/${i+1}.png`)}} />
                              </Col>
                            ))}
                    </Row>
                    {/* <Categories className="d-md-none d-lg-none d-xl-none categoryCarousel" info={fakeData2}/> */}
                </UserCardWrapper>

                <div className="view_count">
            Görüntülenme Sayısı: {project.viewCount?.toLocaleString()}
          </div>
                

            </Container>
        </div>
    )
}
export default HomeSection